/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'question': {
    width: 8,
    height: 12,
    viewBox: '0 0 8 12',
    data: '<defs/><path pid="0" id="question" class="cls-1" d="M1871 1032.82h-2v-2.94h1a1.96 1.96 0 1 0-2-1.96h-2a4 4 0 1 1 5 3.8v1.1zm.25 1.96a1.25 1.25 0 1 1-1.25-1.22 1.24 1.24 0 0 1 1.25 1.22z" transform="translate(-1866 -1024)"/>'
  }
})
